<template>
  <div class="list">
    <el-table :data="list" style="width: 100%">
      <el-table-column prop="listTitle" label="标题"> </el-table-column>
      <el-table-column prop="addTime" label="日期"> </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
          <el-button type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-right page">
      <el-pagination background hide-on-single-page layout="prev, pager, next" :pageSize="pageSize" :pageCount="pageCount" @current-change="currentChange">
      </el-pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
export default {
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 12,
      pageCount: 0,
    };
  },
  created() {
    // 加载列表
    this.dataLoad();
  },
  methods: {
    /* del(arg) {
      alert(`本条id：${arg.id}`);
    }, */
    dataLoad() {
      this.$store
        .dispatch("list/getList", {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          tagNames: "生猪",
        })
        .then((data) => {
          const { list, pages } = data;

          this.list = list;
          this.pageCount = pages;
        });
    },
    currentChange(num) {
      this.pageNum = num;
      this.dataLoad();
    },
  },
};
</script>
